<template>
  <div>
    <h3 style="margin-bottom: 12px;">未读消息：{{ unread }}/{{ num }}</h3>
    <div style="position: relative; height: 30px;">
      <div style="position: absolute; right: 40px; top: 0;">
        <el-button type="text" icon="el-icon-view" v-if="unread !== 0" @click="changenotice('changeall', 'a')">全部已读</el-button>
        <el-button type="text" icon="el-icon-delete" v-if="num !== 0" @click="changenotice('deleteall', 'a')">全部删除</el-button>
      </div>
    </div>
    <el-divider></el-divider>
    <div v-if="num == 0" style="text-align: center; padding: 40px 0;">
      <img :src="$img.noinfo" style="width: 100%; max-width: 300px;" />
      <p style="color: #999;">暂无消息通知</p>
    </div>
    <div v-for="notice in tableData" :key="notice.notice_id" style="position: relative; padding: 10px 0;">
      <span style="width: 10px; height: 10px; border-radius: 50%; display: inline-block; background: #f56c6c;" v-if="notice.state === 0"></span>
      <span style="width: 10px; height: 10px; border-radius: 50%; display: inline-block; background: transparent;" v-else></span>
      <span style="margin-left: 20px;">{{ notice.createtime | dataFormat }}</span>
      <span style="margin-left: 20px;">{{ notice.nickname }}</span>
      <span style="margin-left: 20px;">{{ notice.action }}</span>
      <span style="margin-left: 20px;">
        来自 {{ notice.router | platename }}
        <a style="font-size: 16px; color: #0E7490; cursor: pointer;" @click="changenotice('change', notice.notice_id)" :href="`${url}/#/${notice.router}/${notice.content_id}`" target="_blank">{{ notice.content_name }}</a>
      </span>
      <i class="el-icon-delete" style="position: absolute; right: 40px; top: 12px; cursor: pointer; color: #999;" @click="changenotice('delete', notice.notice_id)"></i>
      <el-divider></el-divider>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getNotice, changeNotice } from '@/api'

export default {
  name: 'Notice',
  filters: {
    platename(router) {
      if (router === 'helpcontent') return '问答'
      if (router === 'oldstuffcontent') return '二手交易'
      if (router === 'activitycontent') return '活动'
      return router
    }
  },
  data() {
    return { tableData: [], num: 0 }
  },
  computed: {
    ...mapState({
      unread: (s) => s.user.unread,
      url: (s) => s.url
    })
  },
  created() {
    this.getnoticelist()
  },
  methods: {
    getnoticelist() {
      getNotice({ num: '' }).then((res) => {
        const d = res.data || {}
        this.$store.dispatch('user/setunread', d.count || 0)
        this.tableData = d.list || []
        this.num = d.num || 0
      })
    },
    changenotice(change, notice_id) {
      changeNotice({ change, notice_id }).then(() => {
        this.getnoticelist()
      })
    }
  }
}
</script>
